export function isDesktop() {
    const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
    return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|CrOS/i.test(ua);
}

export function isFirefox(): boolean {
    return typeof navigator !== 'undefined' && navigator.userAgent.includes('Firefox');
}
